import { Injectable } from '@angular/core';
import { TranslateService as NgxTranslate } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';

@Injectable({
  providedIn: 'root',
})
export class TranslateService {
  constructor(
    private $translate: NgxTranslate,
    private cookieService: CookieService
  ) {
    this.get();
  }

  get(): string {
    const langugage = (navigator.languages && navigator.languages[0]) || 'en';
    const browserLang = this.cookieService.get('mg-language')
      ? this.cookieService.get('mg-language')?.includes('es')
        ? 'es'
        : 'en'
      : langugage.includes('es')
      ? 'es'
      : 'en';
    this.$translate.use(browserLang);
    return browserLang;
  }

  update(language: string) {
    this.$translate.use(language);
    this.cookieService.set('mg-language', language);
    const domain = this.getDomain();
    if (domain.virtual) {
      this.cookieService.set('mg-language', language);
    } else {
      this.cookieService.set('mg-language', language, 24, '/', domain.domain);
    }
  }
  init(name: string) {
    return this.$translate.stream(name);
  }

  getDomain() {
    const host = document.location.hostname;
    const firstDotIndex = host.indexOf('.');
    const domain = host.substring(firstDotIndex);
    return {
      domain: domain,
      virtual: host.split('.').length > 2,
    };
  }
}
